export default class Sources
{
    constructor()
    {
        this.instance =
        [
            {
                name: "terrainColor",
                type: "texture",
                path: "/textures/dirt/color.jpg"
            },
            {
                name: "terrainNormal",
                type: "texture",
                path: "/textures/dirt/normal.jpg"
            },
            {
                name: "foxModel",
                type: "gltfModel",
                path: "/models/Fox/glTF/Fox.gltf"
            },

            //....
        ]
    }
}